import { take, call, select, put } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { PROGRAM_CINEMAS } from "../../constants/state"
import getData from "../../functions/getData"
import { getAllNewsletters } from "../../apis/wpApi/apiCalls"
import authUser from "../../apis/wpApi/authUser"

export const getCinemas = state => ({ 
    cinemas: getData(state, PROGRAM_CINEMAS)
})


export function* onSuccess(successType, data) {
    yield put({
        type: successType, 
        payload: data
    })
}

export function* onError(errorType, errorMessage) {
    yield put({
        type: errorType,  
        payload: {
            errorMessage: errorMessage
        }
    })
}

export function* getCampaignsData(response) {
    if(!response.data || !response.data.items) {
        throw new Error('No data from api')
    } else {
        return yield {
            items: response.data.items,
            order: Object.keys(response.data.items)
        }
    }
}

function* getCampaigns(payload){
    const successType = yield actionTypes.NEWSLETTER_GET_CAMPAIGNS_SUCCESS
    const errorType = yield actionTypes.NEWSLETTER_GET_CAMPAIGNS_ERROR

    try {
        const apiKey = yield call(authUser.getToken)
        const { cinemas } = yield select(getCinemas)
        const cinemasPKS = yield Object.keys(cinemas.toJS())
        const response = yield call(getAllNewsletters, apiKey, payload.signal, {cinemas: cinemasPKS})

        yield call(onSuccess, successType, yield getCampaignsData(response))
    } catch(e){
        yield call(onError, errorType, e.message)
    }
}

function* watchCampaignsRequest() {
    try {
        while(true) {
            const request = yield take(actionTypes.NEWSLETTER_GET_CAMPAIGNS_REQUEST)

            yield call(getCampaigns, request.payload)
        }

    } catch(e) {
        console.log('error!!!!!', e.message)
    }
}


export default watchCampaignsRequest;